/**
 * Classe de base pour les erreurs personnalisées de l'application.
 * Permet d'assurer la cohérence et d'ajouter des fonctionnalités communes aux erreurs.
 */
export class BaseError extends Error {
  /**
   * La cause originale de l'erreur, si disponible.
   */
  public readonly cause?: unknown;

  /**
   * Horodatage de la création de l'erreur.
   */
  public readonly timestamp: Date;

  /**
   * Crée une instance de BaseError.
   * @param message Le message d'erreur.
   * @param cause La cause originale de l'erreur (facultatif).
   */
  constructor(message: string, cause?: unknown) {
    super(message);
    // Définit le prototype explicitement pour que 'instanceof BaseError' fonctionne correctement.
    Object.setPrototypeOf(this, BaseError.prototype);
    this.name = this.constructor.name;
    this.cause = cause;
    this.timestamp = new Date();

    // Capture la pile d'appels, si disponible (environnement V8).
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

